import {CERTIFICATE_FIELDS_FALLBACK_EN} from 'organization/Event/Certification/certificateDefaultFields'

export type BorderStyle = {
  id: number
  label?: string
  strokeWidth: number
  dash?: number[]
  inset?: number
}
export type ShapeDecoration =
  | {
      type: 'ribbon'
      x: number
      y: number
      width: number
      height: number
      color?: string
    }
  | {
      type: 'corner-flourish'
      side: 'tl' | 'tr' | 'bl' | 'br'
      size: number
      color?: string
    }
  | {
      type: 'stripe'
      x: number
      y: number
      width: number
      height: number
      rotate?: number
      color?: string
    }
  | {
      type: 'circle-decor'
      cx: number
      cy: number
      r: number
      color?: string
      opacity?: number
    }
export interface Decoration {
  border?: BorderStyle
  titleY?: number
  recipientY?: number
  descriptionY?: number
  shapes?: ShapeDecoration[]
}
export interface CertificateTemplate {
  templateId: string
  meta: {name: string; nameKey?: string}
  signature: string | null
  layout: {
    width: number
    height: number
    fontFamily: string
    themeColor: string
    backgroundColor: string
  }
  decoration?: Decoration
  fields: {
    title: string
    subtitle?: string
    recipientName: string
    description?: string
    issuer: string
    date: string
  }
}

function tpl(
  templateId: string,
  meta: {name: string; nameKey: string},
  themeColor: string,
  background: string,
  decoration?: CertificateTemplate['decoration'],
): CertificateTemplate {
  return {
    templateId,
    meta,
    signature: null,
    layout: {
      width: 1200,
      height: 850,
      fontFamily: 'Georgia, serif',
      themeColor,
      backgroundColor: background,
    },
    decoration,
    fields: {...CERTIFICATE_FIELDS_FALLBACK_EN},
  }
}
export const TEMPLATES: CertificateTemplate[] = [
  tpl(
    'tpl-рамка',
    {name: 'Frame', nameKey: 'orgCert.templateName.ramka'},
    '#16a085',
    '#f1fdf9',
    {
      border: {id: 1, strokeWidth: 10, inset: 60},
      titleY: 200,
      recipientY: 460,
      descriptionY: 520,
      shapes: [
        {type: 'corner-flourish', side: 'tl', size: 48, color: '#16a085'},
      ],
    },
  ),

  tpl(
    'tpl-кръгове',
    {name: 'Circles', nameKey: 'orgCert.templateName.circles'},
    '#1f6feb',
    '#ffffff',
    {
      border: {id: 1, strokeWidth: 6, inset: 26},
      titleY: 120,
      recipientY: 400,
      descriptionY: 480,
      shapes: [
        {
          type: 'circle-decor',
          cx: 0,
          cy: 760,
          r: 200,
        },
      ],
    },
  ),

  tpl(
    'tpl-фокус',
    {name: 'Focus', nameKey: 'orgCert.templateName.focus'},
    '#c0392b',
    '#fff5f5',
    {
      border: {id: 1, strokeWidth: 6, inset: 24, dash: [6, 6]},
      titleY: 140,
      recipientY: 430,
      descriptionY: 500,
      shapes: [
        {
          type: 'ribbon',
          x: 80,
          y: 380,
          width: 1040,
          height: 64,
        },
      ],
    },
  ),

  tpl(
    'tpl-минимал',
    {name: 'Minimal', nameKey: 'orgCert.templateName.minimal'},
    '#7f8c8d',
    '#f9f9f9',
    {
      border: {id: 1, strokeWidth: 2, inset: 18},
      titleY: 140,
      recipientY: 390,
      descriptionY: 460,
      shapes: [
        {
          type: 'circle-decor',
          cx: 1000,
          cy: 140,
          r: 40,
        },
      ],
    },
  ),

  tpl(
    'tpl-компактно',
    {name: 'Compact', nameKey: 'orgCert.templateName.compact'},
    '#e67e22',
    '#fff3e6',
    {
      border: {id: 1, strokeWidth: 6, inset: 22},
      titleY: 120,
      recipientY: 320,
      descriptionY: 380,
      shapes: [
        {
          type: 'stripe',
          x: 15,
          y: 600,
          width: 1170,
          height: 235,
        },
      ],
    },
  ),

  tpl(
    'tpl-диагонал',
    {name: 'Diagonal', nameKey: 'orgCert.templateName.diagonal'},
    '#2980b9',
    '#eaf4fc',
    {
      border: {id: 1, strokeWidth: 5, inset: 30, dash: [12, 6]},
      titleY: 160,
      recipientY: 420,
      descriptionY: 480,
      shapes: [
        {
          type: 'stripe',
          x: 570,
          y: -700,
          width: 600,
          height: 120,
          rotate: 45,
          color: '#2980b9',
        },
      ],
    },
  ),

  tpl(
    'tpl-диагонал-2',
    {name: 'Diagonal II', nameKey: 'orgCert.templateName.diagonal2'},
    '#2980b9',
    '#eaf4fc',
    {
      border: {id: 1, strokeWidth: 5, inset: 30, dash: [12, 6]},
      titleY: 160,
      recipientY: 420,
      descriptionY: 480,
      shapes: [
        {
          type: 'stripe',
          x: 50,
          y: -200,
          width: 1400,
          height: 120,
          rotate: 45,
        },
      ],
    },
  ),
]
